import { useContext, useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../admin/contexts/AuthContext";
import { SiteContext } from "../contexts/SiteContext";
import {
	Button,
	Fade,
	AppBar,
	Toolbar,
	makeStyles,
	Menu,
	MenuItem,
} from "@material-ui/core";
import DashboardIcon from "@material-ui/icons/Dashboard";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";

const useStyles = makeStyles((theme) => ({
	root: {
		flexGrow: 1,
		background: "black",
	},
	inner: {
		maxWidth: process.env.REACT_APP_MAX_WIDTH,
		margin: "0 auto",
		background: "none",
	},
	title: {
		flexGrow: 1,
		textDecoration: "none",
		color: theme.palette.primary.contrastText,
	},
	adminButton: {
		color: "white",
		textTransform: "none",
		"&:hover": {
			background: theme.palette.primary.main,
		},
	},
	toolbar: {
		minHeight: 0,
		margin: ".2rem 0",
	},
}));

function AdminBar() {
	const classes = useStyles();
	const { isAuth, user, logout } = useAuth();
	const { selectedSite } = useContext(SiteContext);
	const [anchorEl, setAnchorEl] = useState(null);

	const handleClick = (e) => {
		setAnchorEl(e.currentTarget);
	};

	const handleClose = (e) => {
		setAnchorEl(null);
	};

	if (isAuth) {
		return (
			<Fade in={typeof selectedSite != "undefined"}>
				<div className={classes.root}>
					<AppBar className={classes.inner} position="static" elevation={0}>
						<Toolbar classes={{ dense: classes.toolbar }} variant="dense">
							<section style={{ flexGrow: 1 }}>
								<Button
									startIcon={<DashboardIcon />}
									className={classes.adminButton}
									component={Link}
									to={`/${process.env.REACT_APP_ADMIN_URL}`}
								>
									Admin Dashboard
								</Button>
							</section>
							<section>
								<Button
									onClick={handleClick}
									endIcon={<AccountCircleIcon />}
									className={classes.adminButton}
								>
									Hi, {user.name}
								</Button>
								<Menu
									anchorEl={anchorEl}
									keepMounted
									open={Boolean(anchorEl)}
									onClose={handleClose}
									getContentAnchorEl={null}
									anchorOrigin={{
										vertical: "bottom",
										horizontal: "center",
									}}
									transformOrigin={{
										vertical: "top",
										horizontal: "center",
									}}
								>
									<MenuItem
										onClick={handleClose}
										component={Link}
										to={`${process.env.REACT_APP_ADMIN_URL}/profile`}
									>
										Profile
									</MenuItem>
									<MenuItem
										onClick={(e) => {
											handleClose();
											logout();
										}}
									>
										Log Out
									</MenuItem>
								</Menu>
							</section>
						</Toolbar>
					</AppBar>
				</div>
			</Fade>
		);
	} else return null;
}

export default AdminBar;
